module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/infobg_prevention.36e5b7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/product_info/infobg_prevention.jpg
// module id = D+zj
// module chunks = 0